import io from "socket.io-client";

// // const socket = io(import.meta.env.VITE_socketConnection);
// const socket = io(import.meta.env.VITE_socketConnection, {
//   transports: ["websocket"],
//   reconnection: true,
//   reconnectionAttempts: 10,
//   reconnectionDelay: 5000, // 5 seconds delay between attempts
//   timeout: 20000, // 20 seconds before a connect attempt times out
// });

const socket = io(import.meta.env.VITE_socketConnection, {
  transports: ["websocket"],
  path: "/socket.io/",
  secure: true,
  rejectUnauthorized: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});

socket.on("connect_error", (error) => {
  console.error("Connection Error:", error);
});

socket.on("error", (error) => {
  console.error("Socket Error:", error);
});

socket.on("connect", () => {
  console.info("socket connected");
});

socket.on("all", (data) => {
  console.info("socket all recieved", data);
  // window.dispatchEvent(new Event('socket.all', data));
});

socket.on("manufacture", (data) => {
  console.info("socket manufacture recieved", data);
  // window.dispatchEvent(new CustomEvent('socket.manufacture', {detail: {...data}}));
});

// socket.on('site-play-mode', (data) => {
//     console.info('socket site-play-mode', data);
//     window.dispatchEvent(new CustomEvent('socket.site-play-mode', {detail: {...data}}));
// });

socket.on("disconnect", (err) => {
  console.info("socket disconnected", e);
});

export const addCamera_checkConnectivity = (payload) => {
  socket.emit("addCamera_checkConnectivity", payload);
};

export const discoverOnvif = (payload) => {
  socket.emit("discoverOnvif", payload);
};

export const ptz = (payload) => {
  socket.emit("ptz", payload);
};

export const register = (eventName) => {
  console.log("register socket event " + eventName);
  socket.on(eventName, (data) => {
    
    // console.log(eventName, data);
    // console.table(  data.data);


    window.dispatchEvent(new CustomEvent(eventName, { detail: { ...data } }));
  });
};

export const unregister = (payload) => {
  console.log("unregister socket event " + payload);
  socket.off(payload);
};
